__turbopack_context__.v({
  "hasFeatureDiscoveryNotification": "MenuItem-module__OqyBga__hasFeatureDiscoveryNotification",
  "icon": "MenuItem-module__OqyBga__icon",
  "iconContainer": "MenuItem-module__OqyBga__iconContainer",
  "inline": "MenuItem-module__OqyBga__inline",
  "link": "MenuItem-module__OqyBga__link",
  "medium": "MenuItem-module__OqyBga__medium",
  "small": "MenuItem-module__OqyBga__small",
  "text": "MenuItem-module__OqyBga__text",
});
